<div class="col-sm-12 p-4">
    <div class=" m-0">
        <div class="container-fluid">
            <div class="row">
                <div>
                    <div class="row">
                        <div class="row col-12">
                            <div class="row col-12">
                                <h4 class="text-center p-2"> <b>{{'Facts' | translate}}</b></h4>
                                <div class="card">
                                    <div class="row">
                                        <div class="col-12">
                                            <button class="btn btn-secondary m-2"
                                                *ngIf="caseObject!=null && caseObject.settings.allowEditBasicData"
                                                (click)="addFact(AddFact)" href="javascript:void(0);">
                                                <i class="fa fa-plus-circle"></i>
                                                <span> {{ "InsertFact" | translate }} </span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <table class="table table-striped mt-3">
                                            <thead class="thead-dark">
                                                <tr>
                                                    <th scope="col">{{"NumberFact" | translate }} </th>
                                                    <th scope="col"> {{"Description" | translate }} </th>
                                                    <th scope="col" *ngIf="caseObject!=null && caseObject.settings.allowEditBasicData"> {{"Edit" | translate }}</th>
                                                    <th scope="col" *ngIf="caseObject!=null && caseObject.settings.allowEditBasicData"> {{"Delete" | translate }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let fact of caseFactList">
                                                    <td>{{ fact.caseFactId }}</td>
                                                    <td>{{ fact.description }}</td>
                                                    <td *ngIf="caseObject!=null && caseObject.settings.allowEditBasicData">
                                                        <a (click)="UpdateFact(fact, eidtfactmodal)"
                                                            href="javascript:void(0);">

                                                            <i class="fa fa-edit"></i></a>
                                                    </td>
                                                    <td *ngIf="caseObject!=null && caseObject.settings.allowEditBasicData">
                                                        <a (click)="DeleteFact(fact.caseFactId, mymodal)"
                                                            href="javascript:void(0);">
                                                            <i class="fa fa-trash"></i></a>
                                                    </td>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<ng-template #mymodal let-modal>
    <div class="modal-header" style="justify-content: center">
        <h2 class="modal-title fs-5 text-secondary" id="modal-basic-title">
            {{ "ConfirmDeleteOperation" | translate }}
        </h2>
    </div>
    <div class="modal-body text-center py-2 px-3">
        <p>{{ "SelectedRecordwillbeDeleted" | translate }}</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="onDeleteFact()">
            {{ "YES" | translate }}
        </button>
        <button type="button" class="btn btn-dark" (click)="modal.dismiss('Cross click')">
            {{ "NO" | translate }}
        </button>
    </div>
</ng-template>


<ng-template #AddFact let-modal>
    <div class="TransApp">
        <div class="modal-header">
            <h2 class="fs-5 mb-0 text-secondary">
                {{ "InsertFact" | translate }}
            </h2>
        </div>
        <div class="modal-body text-center">
            <div class="form-group mt-3 row">
                <div class="col-1">
                    <label for="CaseTitle">الوقعة</label>
                </div>

                <div class="col-9">
                    <ng-select class="form-control-select" [items]="facts" bindLabel="title" bindValue="description"
                        (change)="factSelected($event)" [(ngModel)]="fact" [ngModelOptions]="{standalone: true}"
                        placeholder="{{'Facts'|translate}}">
                    </ng-select>

                </div>

            </div>
            <br />
            <div class="form-group row">
                <div class="col-12">
                    <textarea [(ngModel)]="casefacts" style="height:250px;" class="form-control"></textarea>
                </div>

            </div>

        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary" (click)="onAddFact()">
                {{ "Save" | translate }}
            </button>
            <button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="clear()">
                {{ "cancel" | translate }}
            </button>
        </div>
    </div>
</ng-template>
<ng-template #eidtfactmodal let-modal>
    <div class="TransApp">

        <div class="modal-header">
            <h2 class="fs-5 mb-0 text-secondary">
                {{'Edit' | translate}} {{'Fact' | translate}}
            </h2>
        </div>
        <div class="modal-body text-center py-2 px-3">
            <div class="form-group row">
                <div class="col-1">
                    <label for="CaseTitle">الوقعة</label>

                </div>

                <div class="col-9">
                    <ng-select class="form-control-select" [items]="facts" bindLabel="title" bindValue="factId"
                        (change)="factSelectedEdit($event)" [(ngModel)]="factIdEdit"
                        [ngModelOptions]="{standalone: true}" placeholder="{{'Facts'|translate}}">
                    </ng-select>

                </div>

            </div>
            <br />
            <div class="form-group row">
                <div class="col-12">
                    <textarea [(ngModel)]="descriptionEdit" style="height:250px;" class="form-control"></textarea>
                </div>

            </div>

        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary" (click)="onUpdateFact()">
                {{ "Save" | translate }}
            </button>
            <button type="button" class="btn btn-danger" (click)="modal.dismiss('Cross click')">
                {{ "cancel" | translate }}
            </button>
        </div>
    </div>
</ng-template>

